"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _tinymceReact = require("@tinymce/tinymce-react");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default(_ref) {
  var value = _ref.value,
      onEditorChange = _ref.onEditorChange;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_tinymceReact.Editor, {
      apiKey: "dey7biuznzq2epjw03p30y3onpvmxuyv6qwf1dan7ab2kb56",
      value: value,
      init: {
        height: 200,
        menubar: false,
        plugins: ['advlist autolink lists link image charmap print preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table paste code help wordcount'],
        toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
      },
      onEditorChange: onEditorChange
    })
  );
};

exports["default"] = _default;